enum Ethnicity {
    WHITE = 'WHITE',
    BLACK = 'BLACK',
    BROWN = 'BROWN',
    YELLOW = 'YELLOW',
    INDIGENOUS = 'INDIGENOUS'
}

export default Ethnicity;
